export const CONSTANTS = {
    POWER_METER: 'power-meter-token',
    NAME: 'borewell-name',
    ROLE: 'borewell-role'
}